import { Color, getContrastRatio, PaletteOptions } from "@mui/material";

declare module "@mui/material" {
  interface TypeText {
    required?: string;
    muted?: string;
  }

  interface Palette {
    indigo: Color;
  }

  interface PaletteOptions {
    indigo: Color;
  }
}

const Palette: PaletteOptions = {
  common: {
    black: "#171717",
  },
  background: {
    default: "#ffffff",
  },
  primary: {
    main: "#6B04FD",
    light: "#4B05AD",
    dark: "#4B05AD",
    contrastText: getContrastRatio("#6B04FD", "#fff") > 4.5 ? "#fff" : "#111",
  },
  text: {
    required: "#db3131",
  },
  error: {
    main: "#FF2929",
    dark: "#ff6464",
    light: "#FFEBEB",
    contrastText: getContrastRatio("#FF2929", "#fff") > 4.5 ? "#fff" : "#111",
  },
  success: {
    main: "#008000",
  },
  indigo: {
    50: "#f3f1ff",
    100: "#ebe5ff",
    200: "#d9ceff",
    300: "#BEA6FF",
    400: "#9F75FF",
    500: "#843DFF",
    600: "#7916FF",
    700: "#6B04FD",
    800: "#5A03D5",
    900: "#4B05AD",
    A100: "",
    A200: "",
    A400: "",
    A700: "",
  },
};

export default Palette;
